[
  { "code": "Custom Value", "label": "Custom Value" },
  { "code": "gs1:activityIdeas", "label": "Activity Ideas" },
  { "code": "gs1:allergenInfo", "label": "Allergen Info" },
  { "code": "gs1:brandHomepageClinical", "label": "Brand Homepage Clinical" },
  { "code": "gs1:careersInfo", "label": "Careers Info" },
  { "code": "gs1:allergenInfo", "label": "Allergen Info" },
  { "code": "gs1:certificationInfo", "label": "Certification Info" },
  { "code": "gs1:consumerHandlingStorageInfo", "label": "Consumer Handling Storage Info" },
  { "code": "gs1:defaultLink", "label": "Default Link" },
  { "code": "gs1:defaultLinkMulti", "label": "Default Multi Link" },
  { "code": "gs1:epcis", "label": "EPCIS" },
  { "code": "gs1:epil", "label": "EPIL" },
  { "code": "gs1:eventsInfo", "label": "Events Info" },
  { "code": "gs1:faqs", "label": "Faqs" },
  { "code": "gs1:handledBy", "label": "Handled By" },
  { "code": "gs1:hasRetailers", "label": "Has Retailers" },
  { "code": "gs1:homepage", "label": "Homepage" },
  { "code": "gs1:ingredientsInfo", "label": "Ingredients Info" },
  { "code": "gs1:instructions", "label": "Instructions" },
  { "code": "gs1:jws", "label": "JWS" },
  { "code": "gs1:leaveReview", "label": "leave Review" },
  { "code": "gs1:locationInfo", "label": "Location Info" },
  { "code": "gs1:logisticsInfo", "label": "Logistics Info" },
  { "code": "gs1:masterData", "label": "Master Data" },
  { "code": "gs1:menuInfo", "label": "Menu Info" },
  { "code": "gs1:nutritionalInfo", "label": "Nutritional Info" },
  { "code": "gs1:openingHoursInfo", "label": "Opening Hours Info" },
  { "code": "gs1:paymentLink", "label": "Payment Link" },
  { "code": "gs1:pip", "label": "Pip" },
  { "code": "gs1:productSustainabilityInfo", "label": "Product Sustainability Info" },
  { "code": "gs1:promotion", "label": "Promotion" },
  { "code": "gs1:purchaseSuppliesOrAccessories", "label": "Purchase supplies or accessories" },
  { "code": "gs1:quickStartGuide", "label": "Quick start guide" },
  { "code": "gs1:recallStatus", "label": "Recall status" },
  { "code": "gs1:recipeInf", "label": "Recipe Inf" },
  { "code": "gs1:registerProduct", "label": "Register Product" },
  { "code": "gs1:registryEntry", "label": "Registry Entry" },
  { "code": "gs1:relatedVideo", "label": "Related Video" },
  { "code": "gs1:review", "label": "Review" },
  { "code": "gs1:safetyInfo", "label": "Safety Info" },
  { "code": "gs1:scheduleTime", "label": "Schedule Time" },
  { "code": "gs1:serviceInfo", "label": "Service Info" },
  { "code": "gs1:smartLabel", "label": "Smart Label" },
  { "code": "gs1:smpc", "label": "SMPC" },
  { "code": "gs1:socialMedia", "label": "Social Media" },
  { "code": "gs1:statisticInfo", "label": "Statistic Info" },
  { "code": "gs1:support", "label": "Support" },
  { "code": "gs1:sustainabilityInfo", "label": "Sustainability Info" },
  { "code": "gs1:traceability", "label": "Traceability" },
  { "code": "gs1:tutorial", "label": "Tutorial" },
  { "code": "gs1:userAgreement", "label": "User Agreement" },
  { "code": "gs1:verificationService", "label": "Verification Service" },
  { "code": "gs1:whatsInTheBox", "label": "Whats in the box" }
]
